export default {
  text_input: {
    note: {
      place_holder: 'Notă...',
    },
  },
  buttons: {
    cancel: 'Anulează',
    save: 'Salvează',
  },
};
